export default "__VITE_ASSET__DMR1FBLH__"